// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3Yl6s","requiredAsterisk":"Info_requiredAsterisk__ybp8s"};